 <template>
  <el-card v-loading="loading">
    <section class="flex justify-bet wrap">
      <div class="flex wrap">
        <el-input
          style="width: 250px"
          class="mt-3 mr-5"
          v-model="input"
          placeholder="Address"
          @keyup.enter.native="filterTable"
          @blur="filterTable"
          clearable
          @clear="filterTable"
          prefix-icon="el-icon-search"
        ></el-input>
        <el-date-picker
          v-model="date"
          class="mt-3"
          clearable
          type="daterange"
          start-placeholder="Start"
          end-placeholder="End"
          value-format="timestamp"
          @change="filterTable"
          style="width: 250px"
        ></el-date-picker>
      </div>
      <!-- <div class="mt-3">
        <vs-button @click="transactionListBlob" size="small" type="border">Export</vs-button>
      </div>-->
    </section>
    <el-table
      ref="multipleTable"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      stripe
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        show-overflow-tooltip
        sortable
        prop="id"
        label="ID"
        width="150"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        sortable
        prop="address"
        label="Address"
      >
        <template slot-scope="scope">
          <span class="text-elli">{{ scope.row.address }}</span>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        sortable
        prop="create_time"
        label="Datetime"
      ></el-table-column>
      <el-table-column label="Action" width="150">
        <template slot-scope="scope">
          <vs-button
            @click="showDialog(scope.row)"
            size="small"
            color="primary"
            type="border"
            >Details</vs-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="flex flex-end mt-5"
      @current-change="handleCurrentChange"
      :current-page="page"
      :pager-count="5"
      layout="total, prev, pager, next"
      :total="total"
    ></el-pagination>

    <vs-popup title="Detail" :active.sync="dialogVisible">
      <el-row>
        <el-col :span="24">
          <ul class="activeUl">
            <li>
              <span>ID:</span>
              <span>{{ dialogData.id }}</span>
            </li>
            <li>
              <span>Address:</span>
              <span style="color: #67c23a">{{ dialogData.address }}</span>
            </li>
            <li>
              <span>Symbol:</span>
              <span>{{ dialogData.symbol }}</span>
            </li>
            <li>
              <span>Message:</span>
              <span>{{ dialogData.msg }}</span>
            </li>
            <li>
              <span>Api Request:</span>
              <json-viewer :value="api_request"></json-viewer>
            </li>
            <li>
              <span>Api Return:</span>
              <json-viewer :value="api_return"></json-viewer>
            </li>
          </ul>
        </el-col>
      </el-row>
    </vs-popup>
  </el-card>
</template>

<script>
import JsonViewer from 'vue-json-viewer'
export default {
  data () {
    return {
      loading: true,
      input: "",
      date: "",
      start: 0,
      end: 0,
      tableData: [],
      dialogVisible: false,
      dialogData: {},
      api_request: "",
      api_return: "",
      size: 10,
      page: 1,
      total: 0,

      selectArr: [],
      activePop: false,
      txid: "",
      password: ""
    }
  },

  components: { JsonViewer },
  created () {
    this.defaultDate();
    this.getTable();
  },

  watch: {
    activePop (val) {
      if (!val) {
        this.selectArr = [];
      }

    }
  },

  filters: {
    computedStatus (val) {
      return val == 0 ? "Pedding" : val == 1 ? 'In process' : val == 2 ? 'Completed' : ""

    }
  },
  methods: {
    defaultDate () {
      let today = new Date();//获取当天零点时间戳
      let month = today.getMonth();//1,3,5,7,8,10,12
      let year = new Date().getFullYear();
      let day31 = [1, 3, 5, 7, 8, 10, 12]

      // 判断平年(28)闰年(29)
      let computedYear = (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) ? 29 : 28;
      let day = day31.includes(month) ? 31 : month == 2 && computedYear == 29 ? 29 : month == 2 && computedYear == 28 ? 28 : 30;
      let last = new Date(today.getTime() - day * 24 * 3600 * 1000).getTime();
      this.date = [last, today.getTime()]
    },
    columFunc (row, rowIndex) {
      if (row.withdraw_status) {
        return false
      } else {
        return true
      }
    },

    filterTable () {
      this.page = 1;
      this.getTable();
    },
    getTable () {
      this.$api.logListReq({
        keywords: this.input,
        start_time: this.date ? this.date[0] : "",
        end_time: this.date ? this.date[1] : "",
        size: this.size,
        page: this.page
      }).then(res => {
        console.log(res);
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      })
    },

    // transactionListBlob () {
    //   this.$api.logListReqBlob({
    //     keywords: this.input,
    //     start_time: this.date ? this.date[0] : "",
    //     end_time: this.date ? this.date[1] : "",
    //     download_type: 'Log'
    //   }).then(res => {
    //     this.downLoadFile(res.data, 'Log')
    //   })
    // },

    showDialog (row) {
      this.$api.logDet({
        log_id: row.id
      }).then(res => {
        console.log(res);
        this.dialogData = res.data.data;
        this.api_request = JSON.parse(res.data.data.api_request);
        this.api_return = JSON.parse(res.data.data.api_return);
        this.dialogVisible = true;
      })
    },
    handleSizeChange (val) {
      this.size = val;
      this.getTable();
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getTable();
    }
  }
}
  </script>
 <style lang="scss" scoped>
.activeUl {
  padding: 0 20px 20px;
  > li {
    margin: 0 0 10px;
    display: flex;
    > span:nth-child(1) {
      display: block;
      width: 150px;
      font-weight: 500;
      font-size: 16px;
      padding-right: 10px;
      text-align: right;
    }
    > span:nth-child(2) {
      width: calc(100% - 150px);
    }
  }
}
</style>